window.$s = window.$s || new function() {
  var html = document.querySelector('html');
  this.showLoadingOverlay = function() {
    html.classList.add('show-loading-overlay');
  },
  this.hideLoadingOverlay = function() {
    html.classList.remove('show-loading-overlay');
  }
}
$s.AutoAddRemoveProducts = new function() {
  var debugOutput = !!(new URL(location.href).searchParams.get('debug'));
  function debug() {
    if (debugOutput) {
      console.debug.apply(this, arguments);
    }
  }
  const stringToHash = (string) => {
    let hash = 0;
    if (string.length == 0) return hash;
    for (i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash;
  }


  const CacheOutOfStock = new function() {
    const storage = sessionStorage;
    const storageKey = 'auto_addons_out_of_stock_variants';
    function getVariants() {
      const expireSeconds = 3600;
      let data = JSON.parse(storage.getItem(storageKey) || '{}');
      if (!data.update_ts || data.update_ts + expireSeconds*1000 < new Date().getTime()) {
        data = {update_ts: new Date().getTime()};
      }
      return data;
    }
    this.filterOutOfStock = async function(variants, variantsRequiredQuantities) {
      const data = getVariants();
      const variantsToCheck = variants.filter(id=>!data[id]);
      const ret = {};
      const requests = [];
      const newOutOfStock = [];
      variantsToCheck.forEach(id=>{
        const request = $s.get({url:'/variants/'+id+'?section_id=variant_info'}).then(data=>{
          const info = JSON.parse(data.substring(data.indexOf('>')+1, data.lastIndexOf('</')));
          if (info.available && (info.inventory_policy=='continue' || variantsRequiredQuantities[id] <= info.inventory_quantity)) {
            ret[id] = 1;
          } else {
            newOutOfStock.push(id);
          }
        });

        requests.push(request);
      });
      await Promise.all(requests);
      if (newOutOfStock.length > 0) {
        const newData = getVariants();
        newOutOfStock.forEach(id=>{newData[id] = 1});
        storage.setItem(storageKey, JSON.stringify(newData));
      }

      return ret;
    }
    
  }
  
  //standalone post method
  function postUpdate(url, data) {
    var headers = {}
    if (!(data instanceof FormData || typeof data==='string')) {
      headers["Content-Type"] = "application/json";
    }
    return fetch(url, {
      "method": "POST",
      "body": (data instanceof FormData || typeof data==='string' ? data : JSON.stringify(data)),
      "headers": headers
    }).then(res => res.json())
  }

  var autoAddRemoveProductsRules = [];
  function createSettings(promoName, allowedItems = [], autoRemove = true, maxUses = 1) {
    var allowedItems = allowedItems||[];
    allowedItems.forEach(x=> {
      if (!x.properties) x.properties = {};
      x.properties._promo = promoName;
      
    });
    return {"promoName": promoName, "allowedItems": allowedItems, "autoRemove": autoRemove, "maxUses": maxUses };
  }
  function createConditionRequiredDiscountCode(discountCode) { 
    var condition = createConditionCustom(function(cart) {
      var hasDiscountCode = false;  
      cart.cart_level_discount_applications.forEach(item=>{
        if(item.title){
          var title = item.title;
        } else {
          var title = item.discount_application.title;
        }
        if (title == discountCode) {
          hasDiscountCode = true;
        }
      });
      return hasDiscountCode;
    });
    return condition;
  }
  function itemMatch(item, query) { //recursive function
    var equal = !!item;
    for (var p in query) {
      if (!equal)
        return false;
      var type = typeof(query[p]);
      if (type=='object') {
        equal = equal && itemMatch(item[p], query[p]);
      } else if(type=='array') {
        for (var i=0; equal && i<item[p].length; i++) {
          equal = equal && item[p][i]===query[p][i];
        }
      } else {
        equal = equal && item[p]===query[p];
      }
    }
    return equal;
  }
  function findItems(cart, itemQuery) {
    var items = cart.items.filter(function(item) {
        return itemMatch(item, itemQuery);
      });
    return items;
  }
  function createCartFilter(itemQueries) {
    return function(cart, promoName) {
      var newCart = Object.assign({}, cart);
      if ($s.AutoAddRemoveProductsCart.itemsToExclude[promoName]) {
        newCart.items = newCart.items.filter(item=>{
          var ok = (item.properties && item.properties._promo == promoName)
            || $s.AutoAddRemoveProductsCart.itemsToExclude[this.settings.promoName].indexOf(item.id) == -1;
          return ok;
        });
      }
      if (itemQueries.length > 0) {
        newCart.items = newCart.items.filter(item=>{
          if (item.properties && item.properties._promo == promoName) {
            return true;
          }

          for (var i=0; i<itemQueries.length; i++) {
            if (itemMatch(item, itemQueries[i])) {
              return true;
            }
          }
          return false;
        });
      }
      return newCart;
    }
  }
  function createConditionMinAmount(amount) { //amount in dollars with decimals
    amount = amount * 100;
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          
          total += item.original_line_price
          
        }
      });
      if (amount>0) {
        var times = Math.floor(total/amount);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return (total >= amount);
    });
    return condition;
  }
  function createConditionMaxAmount(amount) { //amount in dollars with decimals
    amount = amount * 100;
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          
          total += item.original_line_price
          
        }
      });

      var times = total<amount ? 1 : 0;
      cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);

      return (total<amount);
    });
    return condition;
  }
  function createConditionMinQuantity(minQuantity) { //min quantity of products to pass the requirements
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._promo) {
          total += item.quantity
        }
      });
      if (minQuantity>0) {
        var times = Math.floor(total/minQuantity);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return (total >= minQuantity);
    });
    return condition;
  }

  function calcPassedUses(passedTimes, settings) {
    var uses = settings.maxUses ? settings.maxUses : passedTimes; //if not maxUses, then there is no limit;
    return (passedTimes>1 ? Math.min(uses, passedTimes) : 1);
  }
  
  //recommended to validate the quantity of promo items in cart, you should include filter "properties: {_promo: promoName}"
  function createConditionMaxQuantity(itemQuery, maxQuantity) {  //object with line_item attributes. | integer
    var condition = createConditionCustom(function(cart, settings) {
      var itemsPromo = findItems(cart, itemQuery);
      var total = 0;
      itemsPromo.forEach(item=>{total += item.quantity});
      var uses = calcPassedUses(cart.passedTimes, settings);
      if (uses>1) {
        return total <= maxQuantity * uses;
      }
      return total<=maxQuantity;
    });
    return condition;
  }
  function createConditionCustom(conditionLogic) {
    var condition = new function() {
      this.logic = conditionLogic;
    }
    return condition;
  }
  function createActionAllowGWP() {
    var action = createActionCustom(function(rule, settings, cart, requirementsPassed) {
      var query = {properties: {_promo: settings.promoName}};
      var itemsPromo = findItems(cart, query);
      if (requirementsPassed) {
        debug('AutoAddons: requirements passed');
        settings.allowedItems.forEach(function(item) {
          var itemExist = itemsPromo.find(i=>i.id==item.id);
          cart.passedUses = calcPassedUses(cart.passedTimes, settings); //if not maxUses, then there is no limit;
          item.quantity = item.maxQuantity * cart.passedUses;
          if (!itemExist) {
            if (item.autoAdd) {
              if (item.one_by_product) {
                var existingItem = itemsPromo.find(i=>i.product_id==item.product_id);
                if (!existingItem) {
                  const variantOptions = settings.allowedItems.filter(x=>x.product_id==item.product_id).map(x=>{return 'gid://shopify/ProductVariant/'+x.id });
                  item.properties['_edit_options'] = JSON.stringify({v:variantOptions});
                  rule.cartOut.addItems.push(item);
                  debug('AutoAddons: add One By Product', item);
                }
              } else {
                rule.cartOut.addItems.push(item);
                debug('AutoAddons: add', item);
              }
            } else {
              rule.cartOut.allowItems.push(item);
              debug('AutoAddons: no action because autoAdd is false', item);
            }
          } else {
            if (item.quantity != itemExist.quantity) {
              itemExist = Object.assign({}, itemExist); //copy to not modify the source
              if (item.autoAdd || item.quantity < itemExist.quantity) {
                itemExist.quantity = item.quantity;
                rule.cartOut.updateItems.push(itemExist);
                debug('AutoAddons: update item quantity');
              } else {
                itemExist.quantity = item.quantity - itemExist.quantity; //quantity allowed to increase;
                rule.cartOut.allowItems.push(itemExist);
                debug('AutoAddons: allow item:', item, '\nno update because item.autoAdd=' + (item.autoAdd?'true':'false') + ', item.quantity=' + item.quantity + ', itemExist.quantity=' + itemExist.quantity);
              }
            } else {
              debug('AutoAddons: no action, item already in cart');                
            }
          }
        })
      } else {
        debug('AutoAddons: requirements not passed');
        if (itemsPromo.length>0) {
          if (settings.autoRemove) {
            itemsPromo.forEach(x=>x.quantity = 0);
            rule.cartOut.updateItems = itemsPromo;
            debug('AutoAddons: remove', itemsPromo);
          } else {
            debug('AutoAddons: autoremove=false, invalid item remains in cart');
          }
        } else {
          debug('AutoAddons: no action, item not in cart');
        }
      }
    });
    return action;
  }
  function createActionCustom(actionLogic) { //actionLogic is a function with parameters: rule, settings, cart, requirementsPassed
    var action = new function() {
      this.logic = actionLogic;
    }
    return action;
  }
  class Rule extends EventTarget {
    constructor(settings, requiredConditions, action, cartFilter) {
      super();
      this.settings = settings;
      this.requiredConditions = requiredConditions;
      this.action = action;
      this.cartOut = null;
      this.cartFilter = cartFilter;
      this.run = (cart) => {
        this.cartOut = {addItems: [], updateItems: [], allowItems: []};
        var cartForConditions = this.cartFilter(cart, this.settings.promoName);
        cartForConditions.passedTimes = -1;
        var passed = validateConditions(cartForConditions, this.requiredConditions, this.settings);
        cart.passedTimes = cartForConditions.passedTimes;
        this.action.logic(this, this.settings, cart, passed);
        this.dispatchEvent(new CustomEvent('run', {detail: {rule: this, passed}}));

        return passed;
      }
      this.start = ()=> {
        if (autoAddRemoveProductsRules.indexOf(this)==-1) {
          autoAddRemoveProductsRules.push(this);
        }
      }
      this.stop = ()=> {
        var index = autoAddRemoveProductsRules.indexOf(this);
        if (index>-1) {
          autoAddRemoveProductsRules.splice(index, 1);
        }
      }
      this.start();
    }
  }
  function createRule(settings, requiredConditions, action, cartFilter)  {
    var rule = new Rule(settings, requiredConditions, action, cartFilter);
    return rule;
  }
  function validateConditions(cart, conditions, settings) { //returns true if all conditions are met, otherwise return false
    return !conditions.find(c=>{var r = !c.logic(cart, settings); if (r){debug('AutoAddons: condition not passed', c.logic)}; return r;});
  }
  function getRules() {
    return autoAddRemoveProductsRules;
  }
  function runAllRules(cart, updateCart=true) {
    var cartOut = {addItems: [], updateItems: [], allowItems: []};
    var validPromos = [];
    var promise = new Promise(async (resolve, reject)=> {

      if (window.Shopify && Shopify.designMode) {
        resolve({validPromos: validPromos, modified: false});
        return;
      }

      for (var i=0; i<autoAddRemoveProductsRules.length; i++) {
        var rule = autoAddRemoveProductsRules[i];
        var cartCopy = JSON.parse(JSON.stringify(cart));
        if (rule.run(cartCopy)) {
          validPromos.push({promoName: rule.settings.promoName, rule: rule, cart: cartCopy});
        }
        rule.cartOut.addItems.forEach(x=>cartOut.addItems.push(x));
        rule.cartOut.updateItems.forEach(x=>cartOut.updateItems.push(x));
        rule.cartOut.allowItems.forEach(x=>cartOut.allowItems.push(x));
      };

      //remove items from promotions not available, or invalid promo items
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['_promo']) {
          var rule = autoAddRemoveProductsRules.find(rule=>rule.settings.promoName==item.properties['_promo']);
          if (!rule || !rule.settings.allowedItems.find(x=>x.id==item.id) || rule.settings.promo_hash!=item.properties['_promo_hash']) {
            const itemCopy = JSON.parse(JSON.stringify(item));
            itemCopy.quantity = 0;
            cartOut.updateItems.push(itemCopy);
          }
        }
      });

      async function handleError(msg, payload) {
        console.error('Couldn\'t update cart: ', msg, payload);
        var clearResponse = fetch(routes.cart_url + '/clear.json');
        msg += (msg ? '\n\n': '') + lngg.cart__auto_addons_js__error_clear_cart_message;
        alert(msg);
        await clearResponse;
      }

      if (updateCart) {
        var modified = false;
        if (cartOut.updateItems.length > 0 || cartOut.addItems.length > 0) {
          //calculate new total quantity per variant
          //validate those that increase their quantity
          const totalVariantQuantities = {}
          var cartItemsNewQuantity = JSON.parse(JSON.stringify(cart));
          var variantsToValidate = [];

          cartOut.updateItems.forEach(x=>{
            const cartItem = cartItemsNewQuantity.items.find(item=>item.key==x.key);
            if (cartItem) {
              if (cartItem.quantity < x.quantity && variantsToValidate.indexOf(x.id)==-1) {
                variantsToValidate.push(x.id);
              }
              cartItem.quantity = x.quantity;
            }
          });
          cartOut.addItems.forEach(x=>{
            if (variantsToValidate.indexOf(x.id)==-1) {
              variantsToValidate.push(x.id);
            }
            cartItemsNewQuantity.items.push({id: x.id, quantity: x.quantity});
          });
          cartItemsNewQuantity.items.forEach(item=>{
            totalVariantQuantities[item.id] = (totalVariantQuantities[item.id] || 0) + item.quantity;
          });

          //return variants that have enough stock satisfy cart needs
          var inStockVariants = await CacheOutOfStock.filterOutOfStock(variantsToValidate, totalVariantQuantities);

          if (cartOut.updateItems.length > 0) {
            var inStockItems = cartOut.updateItems.filter(x=>{return inStockVariants[x.id] || x.quantity < cart.items.find(item=>item.key==x.key).quantity});
            if (inStockItems.length > 0) {
              var items = {}
              $s.showLoadingOverlay();
              inStockItems.forEach(x=>{items[x.key] = x.quantity});
              var data = {updates: items};
              var newCart = await $s.updateCartItemsQuantity(data)
              modified = true;
              $s.hideLoadingOverlay();
            }
          }
          if (cartOut.addItems.length > 0) {
            var inStockItems = cartOut.addItems.filter(x=>{return inStockVariants[x.id]});
            var items = [];
            inStockItems.forEach(item=>{
              if (!item.one_by_product || !items.find(x=>x.product_id==item.product_id)) {
                items.push(item);
              }
            })
            
            if (items.length>0) {
              $s.showLoadingOverlay();
              var newItem = await postUpdate(routes.cart_url + '/add.js', {items: items});
              if (newItem.status) {
                await handleError(newItem.description, items);
              }
              modified = true;
              $s.hideLoadingOverlay();
            }
          }
        }
        resolve({validPromos: validPromos, modified: modified});
      } else {
        resolve({validPromos: validPromos, modified: false});
      }

    });
    return promise;
  }
  return {
    createSettings: createSettings,
    createConditionRequiredDiscountCode: createConditionRequiredDiscountCode,
    createConditionMinAmount: createConditionMinAmount,
    createConditionMaxAmount: createConditionMaxAmount,
    createConditionMinQuantity: createConditionMinQuantity,
    createConditionMaxQuantity: createConditionMaxQuantity,
    createConditionCustom: createConditionCustom,
    createCartFilter: createCartFilter,
    createActionAllowGWP: createActionAllowGWP,
    createActionCustom: createActionCustom,
    validateConditions: validateConditions,
    createRule: createRule,
    getRules: getRules,
    runAllRules: runAllRules,
    postUpdate: postUpdate,
    stringToHash: stringToHash
  }
}
$s.AutoAddRemoveProductsCart = {itemsToExclude: {} };window.FreeSamples = new function () {
  this.initSections = function(validPromos) {
    validPromos.forEach(function(promo) {
      var section = document.querySelector('.free-samples-selector[data-promo="'+promo.promoName+'"]');
      if (section) {
        section.style.display = 'block';
        const cartPromoitems = promo.cart.items.filter(x=>x.properties && x.properties['_promo']==promo.promoName)
        var allowedQuantity = section.dataset.maxItems * promo.cart.passedUses;

        var selectedQuantity = 0;
        cartPromoitems.forEach((item)=>{selectedQuantity += item.quantity/1;});

        section.querySelectorAll('.section-title .allowed, .section-text .allowed').forEach((elem)=> {
          elem.innerHTML = allowedQuantity;
        });
        section.querySelectorAll('.section-title .selected, .section-text .selected').forEach((elem)=> {
          elem.innerHTML = selectedQuantity;
        });
        section.querySelectorAll('.section-title.single, .section-text.single').forEach((elem)=> {
          elem.style.display = allowedQuantity==1 ? '' : 'none';
        });
        section.querySelectorAll('.section-title.multiple, .section-text.multiple').forEach((elem)=> {
          elem.style.display = allowedQuantity>1 ? '' : 'none';
        });

        var disabled = selectedQuantity >= allowedQuantity;

        const samples = section.querySelectorAll('.item-sample');
        samples.forEach(function(sample) {
          sample.allowedItems = promo.rule.cartOut.allowItems.filter(x=>x.product_id==sample.dataset.productId);
          sample.cartItems = cartPromoitems.filter(x=>x.product_id==sample.dataset.productId);
          sample.addDisabled = disabled;
          sample.settings = promo.rule.settings;
          sample.updateForm();
        });


        var carousel = section.querySelector('component-carousel')
        if (carousel.initSlider) {
          carousel.initSlider();
        } else {
          carousel.setAttribute('data-init-ondemand', 'false');
        }
      }
    });    
  }

}

class ComponentFreeSampleCard extends HTMLElement {
  constructor() {
    super()
    var self = this;
    self.section = this.closest('.free-samples-selector');
    self.util = $s.AutoAddRemoveProducts;
    self.remove = this.querySelector('.remove-sample');
    self.update = this.querySelector('.quantity-input');
    self.add = this.querySelector('.add');
    self.variantSelector = this.querySelector('[name="id"]');
    self.allowedItems = [];
    self.cartItems = [];
    self.addDisabled = true;
    self.settings = null;
    self.updateForm = function() {
      const variantId = self.variantSelector.value;
      const allowedItem = self.allowedItems.find(item=>item.id==variantId);
      const cartItem = self.cartItems.find(item=>item.id==variantId);
      self.setAttribute('data-edit', 'none');
      if (!cartItem) {
        if (allowedItem) {
          self.setAttribute('data-edit', 'add');
        }
      } else {
        self.dataset.key = cartItem.key;
        self.querySelector('.quantity-input').value = cartItem.quantity;
        if (allowedItem) {
          self.setAttribute('data-edit', 'add-quantity');
        } else if (cartItem.quantity>1) {
          self.setAttribute('data-edit', 'remove-quantity');
        } else {
          self.setAttribute('data-edit', 'remove');
        }
      }
      
      self.querySelectorAll('.add, .quantity-button.plus').forEach(function(btn) {
        if (self.addDisabled) {
          btn.setAttribute('disabled', true);
        } else {
          btn.removeAttribute('disabled');
        }
      });

    }
    self.variantSelector.addEventListener('change', self.updateForm);
    self.updateForm();

    async function updateUI() {
      var sectionCart = window.SideCart ? 'side_cart' : 'cart_content';
      $s.getJson({url: routes.root_url + '?sections='+sectionCart, success: async function(data){
        $s.hideLoadingOverlay();
        if (window.SideCart) {
          window.SideCart.openAfterUpdate = true;
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(data[sectionCart], "text/html");
        var addonsJs = doc.querySelector('#cart-addons');
        var itemsManagementJs = doc.querySelector('script[src*="'+sectionCart+'.js"]')

        $s.updateDynamicContent(document.getElementById(sectionCart=='side_cart' ? 'side-cart' : 'cart'), data[sectionCart], '.cart-items');

        await $s.globalEval(addonsJs.outerHTML);
        await $s.globalEval(itemsManagementJs);

      }});

    }

    async function updateQuantity() {
      $s.showLoadingOverlay();
      var data = {updates: {}};
      data.updates[(self.dataset.key || self.dataset.id)] = self.update.value;
      await $s.updateCartItemsQuantity(data);
      updateUI();
    }

    self.remove.addEventListener('click', function() {
      self.update.value = 0;
      updateQuantity();
    });
    self.update.addEventListener('change', function() {
      updateQuantity();
    });
    self.add.addEventListener('click', function() {
      var fd = new FormData();
      this.closest('.add-form').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>fd.append(x.name, x.value));
      fd.append('properties[_edit_options]', '{"r":true}');
      fd.append('properties[_free_sample]', 'true');
      fd.append('properties[_promo_hash]', self.settings.promo_hash);

      $s.showLoadingOverlay();
      self.util.postUpdate(
        routes.cart_url + '/add.js',
        fd
      ).then(function() {
        updateUI();
      });

    });    
  }

}
customElements.define('free-sample-card', ComponentFreeSampleCard);
